import { all, call, put, select, takeLatest } from "redux-saga/effects";
import api from "../../utils/api";
import {
  fetchCareHearthInsightFailure,
  fetchCareHearthInsightsFailure,
  fetchCareHearthInsightsSuccess,
  fetchCareHearthInsightSuccess,
} from "./actions";
import {
  FETCH_CARE_HEARTH_INSIGHT,
  FETCH_CARE_HEARTH_INSIGHTS,
} from "./constants";

const getToken = (state) => state?.AuthReducer?.token;

const getErrorMessage = (error, fallback) => {
  if (typeof error === "string") return error;
  return error?.error || error?.message || fallback;
};

export function* fetchCareHearthInsightsSaga({ payload }) {
  const token = yield select(getToken);

  try {
    const response = yield call(api(token).get, "/api/admin/hearth/insights", {
      params: payload,
    });
    yield put(
      fetchCareHearthInsightsSuccess({
        items: response?.data?.items || [],
        pagination: response?.data?.pagination || { last_page: 1, total: 0 },
        totals: response?.data?.totals || null,
        note: response?.data?.note || null,
        review: response?.data?.review || null,
      }),
    );
  } catch (error) {
    yield put(
      fetchCareHearthInsightsFailure(
        getErrorMessage(error, "Could not load CareHearth insights."),
      ),
    );
  }
}

export function* fetchCareHearthInsightSaga({
  payload: { locationId, from, to },
}) {
  const token = yield select(getToken);

  try {
    const response = yield call(
      api(token).get,
      `/api/admin/hearth/insights/${locationId}`,
      {
        params: { from, to },
      },
    );
    yield put(fetchCareHearthInsightSuccess(response?.data || null));
  } catch (error) {
    yield put(
      fetchCareHearthInsightFailure(
        getErrorMessage(error, "Could not load this care home."),
      ),
    );
  }
}

export default function* CareHearthInsightsSaga() {
  yield all([
    takeLatest(FETCH_CARE_HEARTH_INSIGHTS, fetchCareHearthInsightsSaga),
    takeLatest(FETCH_CARE_HEARTH_INSIGHT, fetchCareHearthInsightSaga),
  ]);
}
